<template>
    <div class="flex size-full flex-row p-4 xl:p-10">
        <div class="mr-8 w-1/2 xl:mr-12">
            <h1 class="mb-2 text-2xl xl:mb-4">{{ t("registerDevice.title") }}</h1>
            <p>{{ t("registerDevice.description") }}</p>

            <div class="flex flex-col items-center justify-center">
                <number-input-with-keyboard v-model="startCode" :code-length="startCodeLength" :show-abort-button="false" @cancel="cancel" />

                <ButtonWithLoadingState
                    :is-loading="isCurrentlyRegistering"
                    :button-text="t('registerDevice.registerDeviceButton')"
                    :loading-text="t('registerDevice.registering')"
                    @click="registerDevice"
                />
            </div>
        </div>
        <div class="w-1/2">
            <h2 class="mb-3 text-xl">{{ t("registerDevice.generateStartCode.header") }}</h2>

            <ol class="list-disc pl-6">
                <li>{{ t("registerDevice.generateStartCode.login") }}</li>
                <li>{{ t("registerDevice.generateStartCode.navigateSettings") }}</li>
                <li>{{ t("registerDevice.generateStartCode.openDevices") }}</li>
                <li>{{ t("registerDevice.generateStartCode.createNewDevice", { length: startCodeLength }) }}</li>
            </ol>

            <p class="mt-4">{{ t("registerDevice.generateStartCode.rememberStartCode") }}</p>
            <p class="mt-4">{{ t("registerDevice.generateStartCode.contactSupport") }} <a href="mailto:support@nesto-software.de">support@nesto-software.de</a></p>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { useRoute } from "vue-router";
    import { useRegisterDevice } from "@/services/register-device.service";
    import { useI18n } from "vue-i18n";
    import { onMounted } from "vue";
    import ButtonWithLoadingState from "../components/ButtonWithLoadingState.vue";
    import NumberInputWithKeyboard from "../components/NumberInputWithKeyboard.vue";

    const { startCode, registerDevice, startCodeLength, isCurrentlyRegistering } = useRegisterDevice();
    const { t } = useI18n({ useScope: "global" });

    const route = useRoute();
    const autoFillStartCode = async () => {
        if (route.query.startCode && !Array.isArray(route.query.startCode)) {
            startCode.value = route.query.startCode;
            await registerDevice();
        }
    };

    onMounted(autoFillStartCode);

    const cancel = () => {
        startCode.value = "";
    };
</script>

<style scoped></style>
